import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";

import { useEffect } from "react";

import liff from "@line/liff";

import { VERSION_APP } from "./Utills/constants";

import LuckySlotMachine1 from "./Components/Main/Slot1";
import LuckySlotMachine2 from "./Components/Main/Slot2";
import LuckySlotMachine3 from "./Components/Main/Slot3";
import LuckySlotMachine4 from "./Components/Main/Slot4";
import LuckySlotMachine5 from "./Components/Main/Slot5";
import LuckySlotMachine6 from "./Components/Main/Slot6";
import LuckySlotMachine7 from "./Components/Main/Slot7";
import LuckySlotMachine8 from "./Components/Main/Slot8";
import LuckySlotMachine9 from "./Components/Main/Slot9";
import LuckySlotMachine10 from "./Components/Main/Slot10";
import LuckySlotMachine11 from "./Components/Main/Slot11";
import LuckySlotMachine12 from "./Components/Main/Slot12";
import LuckySlotMachine13 from "./Components/Main/Slot13";
import LuckySlotMachine14 from "./Components/Main/Slot14";
import LuckySlotMachine15 from "./Components/Main/Slot15";
import LuckySlotMachine16 from "./Components/Main/Slot16";
import LuckySlotMachine17 from "./Components/Main/Slot17";
import LuckySlotMachine18 from "./Components/Main/Slot18";
import LuckySlotMachine19 from "./Components/Main/Slot19";
import LuckySlotMachine20 from "./Components/Main/Slot20";
import LuckySlotMachine21 from "./Components/Main/Slot21";
import LuckySlotMachine22 from "./Components/Main/Slot22";
import LuckySlotMachine23 from "./Components/Main/Slot23";
import LuckySlotMachine24 from "./Components/Main/Slot24";
import LuckySlotMachine25 from "./Components/Main/Slot25";
import LuckySlotMachine26 from "./Components/Main/Slot26";
import LuckySlotMachine27 from "./Components/Main/Slot27";
import LuckySlotMachine28 from "./Components/Main/Slot28";
import NotFound from "./Components/Main/NotFound";

function App() {

  useEffect(() => {
    document.title = `สุ่ม Slot ลุ้นรางวัลใหญ่ (v${VERSION_APP})`;
  }, []);

  useEffect(() => {

    liff.ready.then(() => {

    });
  }, []);
  //basename={`${HOME_DIR}`}
  return (
    <Router>
      <Routes>
        {/* <Route exact path="/" element={<LuckySlotMachine1 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine2 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine3 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine4 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine5 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine6 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine7 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine8 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine9 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine10 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine11 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine12 />} /> */}
        <Route exact path="/" element={<LuckySlotMachine13 />} />
        {/* <Route exact path="/" element={<LuckySlotMachine14 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine15 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine16 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine17 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine18 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine19 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine20 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine21 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine22 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine23 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine24 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine25 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine26 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine27 />} /> */}
        {/* <Route exact path="/" element={<LuckySlotMachine28 />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
